module.exports = __webpack_public_path__ + "img/giovanni-pro.d3e696df.jpg";